import { useNavigate } from "react-router-dom";
import { useStore, useT } from "../store/useStore";
import { Logo } from "./Logo";

const LINKS: Array<[string, string]> = [
  ["footer.imprint", "imprint"],
  ["footer.privacy", "privacy"],
  ["footer.contact", "contact"],
];

export function Footer() {
  const t = useT();
  const navigate = useNavigate();
  const de = useStore((s) => s.lang) === "de";
  const auth = useStore((s) => s.auth);
  return (
    <footer style={{ borderTop: "1px solid var(--glass-border)", padding: "26px 28px", marginTop: 40 }}>
      <div
        style={{
          maxWidth: 1180,
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          gap: 16,
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Logo onClick={() => navigate("/")} />
          <span style={{ fontSize: 12.5, color: "var(--text-mute)" }}>© 2026</span>
        </div>
        <nav style={{ display: "flex", gap: 22 }}>
          {LINKS.map(([k, page]) => (
            <button
              key={k}
              onClick={() => navigate(`/legal/${page}`)}
              style={{ fontSize: 13, fontWeight: 500, color: "var(--text-mute)", background: "none", border: "none", cursor: "pointer" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "var(--text)")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "var(--text-mute)")}
            >
              {t(k)}
            </button>
          ))}
          {/* Funktionswünsche: nur mit Konto, eine Stimme gehört einem Menschen */}
          {auth && (
            <button
              onClick={() => navigate("/wuensche")}
              style={{ fontSize: 13, fontWeight: 600, color: "var(--accent-text)", background: "none", border: "none", cursor: "pointer" }}
              onMouseEnter={(e) => (e.currentTarget.style.textDecoration = "underline")}
              onMouseLeave={(e) => (e.currentTarget.style.textDecoration = "none")}
            >
              {de ? "Funktion wünschen" : "Request a feature"}
            </button>
          )}
        </nav>
      </div>
    </footer>
  );
}
